<share-section-card title="Orders Overview" icon="pi pi-chart-bar">
  <div class="surface-100 border-round p-3 mb-4">
    <span class="text-900 font-bold text-3xl">
      {{ (confirmed / total) * 100 | number: '1.0-0' }}%
      <span class="text-600 text-xl">({{ confirmed }}/{{ total }})</span>
    </span>
    <ul class="mt-3 list-none p-0 mx-0 flex">
      <li
        *ngFor="let summary of orderSummary; let first = first; let last = last"
        [ngClass]="{ 'border-round-left': first, 'border-round-right': last }"
        class="bg-{{ summary.color }}-500"
        style="height: 1rem"
        [style.flex]="'0 0 ' + ((summary.value / total) * 100 | number: '1.0-0') + '%'"
      ></li>
    </ul>
  </div>
  <ul class="list-none p-0 mx-0">
    <li *ngFor="let summary of orderSummary" class="flex align-items-center pb-3">
      <span
        style="width: 1rem; height: 1rem"
        class="border-round bg-{{ summary.color }}-500 mr-3 flex-shrink-0"
      ></span>
      <span class="text-xl font-medium text-900">{{ summary.title }}</span>
      <span class="text-600 text-xl font-medium ml-auto">{{ summary.value }}</span>
    </li>
  </ul>
</share-section-card>
